import React from "react";

import { Documents, Eye, Analytics } from "icons";
import { useNavigate } from "react-router-dom";

import { Button, Tag, Tooltip, Typography } from "clearsense-ui/components";
import { CsvFile } from "components/Common/clearsense-ui/icons";

const Card = ({ dataset }) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col justify-between p-4 bg-white dark:bg-gray-800 rounded-lg shadow-md cursor-pointer hover:shadow-xl min-h-[150px]">
      <div className="flex items-start space-x-3">
        <Documents size="20" className="flex-none mt-[2px]" />
        <Typography style="h3" className="text-base">
          {dataset.filename}
        </Typography>
      </div>

      <div className="flex items-end justify-between mt-3">
        <Typography className="flex flex-col pl-1 text-sm gray-600 text">
          <span>{dataset.rowCount} rows</span>
          <span>{dataset.columnCount} columns</span>
        </Typography>

        <div className="flex items-center space-x-2">
          {dataset.isLocal && (
            <Tag
              label="Local"
              color="#E8F4FD"
              icon={CsvFile}
              className="cursor-default"
            />
          )}
          <Tooltip content="View" position="top">
            <Button
              icon={Eye}
              iconSize="20"
              style="text"
              size="small"
              className="text-current dark:hover:text-white"
              onClick={() => {}}
            />
          </Tooltip>
          <Tooltip content="Analyses" position="top">
            <Button
              icon={Analytics}
              iconSize="20"
              style="text"
              size="small"
              className="text-current dark:hover:text-white"
              onClick={() => navigate(dataset.link, { replace: true })}
            />
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default Card;
